import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { searchGeneralProducts } from '../api/aliApi';

const HeroSection = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    const timeout = setTimeout(() => {
      fetchSuggestions();
    }, 400);

    return () => clearTimeout(timeout);
  }, [query]);

  const fetchSuggestions = async () => {
    setLoading(true);
    try {
      const res = await searchGeneralProducts(query, '', 1);
      const data = res?.aliexpress_ds_text_search_response?.data?.products?.selection_search_product || [];
      setSuggestions(data.slice(0, 6));
      setShowDropdown(true);
    } catch (err) {
      console.error('Search suggestion error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/products?search=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <section
      id="hero"
      className="relative pt-24 sm:pt-28 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('segments/banner.png')" }}
    >
      <div className="absolute inset-0 bg-black/55 backdrop-blur-sm"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center text-white px-4 py-24 sm:py-28">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight mb-5 drop-shadow-md animate-fade-in-up">
          Global Multi-Corridor Sourcing, Commerce & Procurement
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-gray-100 max-w-3xl mx-auto mb-3 leading-relaxed">
          Connecting African consumers, businesses, and institutions to home and lifestyle products across multiple global supply corridors.
        </p>

        <form onSubmit={handleSearch} className="relative max-w-xl mx-auto mb-7">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search products..."
            className="w-full px-5 py-3 pr-12 rounded-full shadow-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 transition"
          />

          {loading && (
            <>
              <div className="absolute top-1/2 right-4 transform -translate-y-1/2">
                <svg className="animate-spin h-5 w-5 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"></path>
                </svg>
              </div>
              <p className="absolute left-0 -bottom-5 text-sm text-green-200 ml-3">Searching for your results, please wait...</p>
            </>
          )}

          {showDropdown && (
            <div className="absolute left-0 right-0 bg-white text-gray-800 rounded-md shadow-lg mt-1 max-h-80 overflow-y-auto z-20">
              {suggestions.length === 0 && !loading ? (
                <p className="p-3 text-sm text-center text-gray-400">No results found</p>
              ) : (
                <>
                  {suggestions.map((product, idx) => (
                    <div
                      key={idx}
                      onClick={() => navigate(`/aliproduct/${product.itemId}`)}
                      className="cursor-pointer hover:bg-gray-100 p-3 flex items-center gap-3 border-b"
                    >
                      <img
                        src={product.itemMainPic || 'https://placehold.co/50x50'}
                        alt="product"
                        className="w-12 h-12 object-cover rounded"
                      />
                      <span className="text-sm line-clamp-2">{product.title}</span>
                    </div>
                  ))}
                  <div
                    onClick={() => navigate(`/products?search=${encodeURIComponent(query)}`)}
                    className="cursor-pointer text-center text-green-600 hover:underline text-sm font-medium py-2"
                  >
                    View more results for "{query}"
                  </div>
                </>
              )}
            </div>
          )}
        </form>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={() => navigate('/products')}
            className="cursor-pointer bg-green-600 hover:bg-green-700 hover:scale-105 px-6 py-3 rounded-full text-white font-semibold transition-all duration-300 shadow-md"
          >
            Explore Products
          </button>
          <button
            onClick={() => navigate('/contact')}
            className="cursor-pointer bg-white text-green-700 hover:bg-gray-100 hover:scale-105 px-6 py-3 rounded-full font-semibold transition-all duration-300 shadow-md"
          >
            Source for Business
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
